import * as AppType from "./types";

export const defaultState: AppType.AppStore = {
  appInfo: {
    appVersion: "",
    pythonVersion: "",
    packageVersions: []
  },
  authToken: "",
  userInfo: {
    username: "Guest",
    userId: "",
    firstName: "",
    lastName: "",
    email: "",
    thumbmnailUrl: "",
    isSuperuser: false,
    watchlist: {},
    priceAlert: [],
    userPreference: {
      lastVisitedWatchlist: "all"
    }
  },
  loading: {
    cache: "SUCCESS",
    userInfo: "SUCCESS"
  },
  cache: []
};
